import { WithStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import MenuIcon from '@material-ui/icons/Menu';
import { push } from 'connected-react-router';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/imstat';
import { IRootState } from '../reducers';
import i18next from '../resources/i18n';
import SearchScenarioFactory from '../scenario/SearchScenarioFactory';
import { isMobile } from '../utils/MobileCheck';
import { Routes, Screens } from '../utils/Routes';

const ITEM_HEIGHT = 48;

export enum CurriculumTypes {
	ONGOING,
	RESULT,
}

const styles = (theme: Theme) =>
	createStyles({
		card: {
			height: '100%',
			width: 200,
		},
		content: {
			padding: theme.spacing(1),
		},
		eLearningTitle: {
			color: theme.palette.primary.main,
			cursor: 'pointer',
			fontSize: '108%',
			marginBottom: theme.spacing(1),
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			wordBreak: 'break-all',
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		media: {
			height: 0,
			paddingTop: '56.25%',
		},
		root: {
			flexGrow: 1,
			padding: 24,
		},
	});

interface IState {
	appCancelOkFlg?: boolean;
	lecCancelOkFlg?: boolean;

	functionMenuAnchorEl?: HTMLElement;
}

/**
 * カリキュラムカード形式
 */
class CurriculumCard extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);

		this.state = {
			appCancelOkFlg: this.props.data.appCancelOkFlg,
			lecCancelOkFlg: this.props.data.lecCancelOkFlg,
		};

		this.handleOpenMenu = this.handleOpenMenu.bind(this);
		this.handleCloseMenu = this.handleCloseMenu.bind(this);
		this.showStCancel = this.showStCancel.bind(this);
		this.showCancelApplication = this.showCancelApplication.bind(this);
		this.showContent = this.showContent.bind(this);
		this.showDetail = this.showDetail.bind(this);
		this.showApplicationStatus = this.showApplicationStatus.bind(this);
		this.handleShowDetailDialog = this.handleShowDetailDialog.bind(this);
	}

	public render() {
		const { classes, data, type } = this.props;
		const { functionMenuAnchorEl } = this.state;

		if (type === CurriculumTypes.ONGOING) {
			return (
				<Card className={classes.card}>
					<CardContent className={classes.content}>
						<Tooltip title={data.careerTitle} placement="top-start">
							<Typography
								variant="h5"
								component="h2"
								className={classes.eLearningTitle}
								onClick={this.handleShowDetailDialog}
							>
								{data.careerTitle}
							</Typography>
						</Tooltip>
						<Typography component="p">
							{(() => {
								const status = i18next.t(data.status, {
									ns: 'force',
								});
								if (
									!isMobile() &&
									['0', '1', '2', '3', '4'].indexOf(
										data.aplType
									) !== -1
								) {
									return (
										<span>
											{i18next.t('CurriculumCard_0001')}
											<span
												className={
													this.props.classes.link
												}
												onClick={
													this.showApplicationStatus
												}
											>
												{status}
											</span>
										</span>
									);
								} else {
									return (
										<span>
											{i18next.t('CurriculumCard_0001')}
											{status}
										</span>
									);
								}
							})()}
						</Typography>
					</CardContent>
					<CardActions>
						{!isMobile() && (
							<>
								<IconButton onClick={this.handleOpenMenu}>
									<MenuIcon />
								</IconButton>
								<Menu
									anchorEl={functionMenuAnchorEl}
									open={Boolean(functionMenuAnchorEl)}
									onClose={this.handleCloseMenu}
									anchorOrigin={{
										horizontal: 'center',
										vertical: 'bottom',
									}}
									transformOrigin={{
										horizontal: 'center',
										vertical: 'top',
									}}
									getContentAnchorEl={undefined}
									PaperProps={{
										style: {
											maxHeight: ITEM_HEIGHT * 4.5,
											width: 200,
										},
									}}
								>
									<MenuItem onClick={this.showContent}>
										{i18next.t('CurriculumCard_0002')}
									</MenuItem>
									<MenuItem onClick={this.showDetail}>
										{i18next.t('CurriculumCard_0003')}
									</MenuItem>
									{this.state.lecCancelOkFlg && (
										<MenuItem onClick={this.showStCancel}>
											{i18next.t('CurriculumCard_0004')}
										</MenuItem>
									)}
									{this.state.appCancelOkFlg && (
										<MenuItem
											onClick={this.showCancelApplication}
										>
											{i18next.t('CurriculumCard_0005')}
										</MenuItem>
									)}
								</Menu>
							</>
						)}
					</CardActions>
				</Card>
			);
		} else if (type === CurriculumTypes.RESULT) {
			return (
				<Card className={classes.card}>
					<CardContent className={classes.content}>
						<Tooltip title={data.careerTitle} placement="top-start">
							<Typography
								variant="h5"
								component="h2"
								className={classes.eLearningTitle}
								onClick={this.handleShowDetailDialog}
							>
								{data.careerTitle}
							</Typography>
						</Tooltip>
						<Typography component="p">
							{(() => {
								const status = i18next.t(data.status, {
									ns: 'force',
								});
								if (
									!isMobile() &&
									['0', '1', '2', '3', '4'].indexOf(
										data.aplType
									) !== -1
								) {
									return (
										<div>
											{i18next.t('CurriculumCard_0001')}
											<span
												className={
													this.props.classes.link
												}
												onClick={
													this.showApplicationStatus
												}
											>
												{status}
											</span>
										</div>
									);
								} else {
									return (
										<div>
											{i18next.t('CurriculumCard_0001')}
											{status}
										</div>
									);
								}
							})()}
						</Typography>
						<Typography component="p">
							{i18next.t('CurriculumCard_0006')}: {data.complDate}
						</Typography>
					</CardContent>
					<CardActions>
						{!isMobile() && (
							<>
								<IconButton onClick={this.handleOpenMenu}>
									<MenuIcon />
								</IconButton>
								<Menu
									anchorEl={functionMenuAnchorEl}
									open={Boolean(functionMenuAnchorEl)}
									onClose={this.handleCloseMenu}
									anchorOrigin={{
										horizontal: 'center',
										vertical: 'bottom',
									}}
									transformOrigin={{
										horizontal: 'center',
										vertical: 'top',
									}}
									getContentAnchorEl={undefined}
									PaperProps={{
										style: {
											maxHeight: ITEM_HEIGHT * 4.5,
											width: 200,
										},
									}}
								>
									<MenuItem onClick={this.showContent}>
										{i18next.t('CurriculumCard_0002')}
									</MenuItem>
									<MenuItem onClick={this.showDetail}>
										{i18next.t('CurriculumCard_0003')}
									</MenuItem>
								</Menu>
							</>
						)}
					</CardActions>
				</Card>
			);
		} else {
			return <div />;
		}
	}

	protected handleShowDetailDialog = (e: React.MouseEvent<HTMLElement>) => {
		const { careerID } = this.props.data;
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: '',
			careerID,
			classID: '',
			curriculumFlg: '0',
			setApplicationStatusDialog: false,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: true,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	};

	/**
	 *
	 * @param event メニューオープンハンドラ
	 */
	protected handleOpenMenu(event: React.MouseEvent<HTMLElement>) {
		this.setState({ functionMenuAnchorEl: event.currentTarget });
	}

	/**
	 * メニュークローズハンドラ
	 */
	protected handleCloseMenu = (event: React.MouseEvent<HTMLElement>) => {
		this.setState({ functionMenuAnchorEl: undefined });
	};

	/**
	 * 申請内容画面表示
	 * @param e イベントオブジェクト
	 */
	protected showApplicationStatus(e: React.MouseEvent<HTMLElement>) {
		let cardData: any;
		if (this.props.data) {
			cardData = this.props.data;
		} else if (this.props.data) {
			cardData = this.props.data;
		}
		const { careerID, aplType } = cardData;
		const careerDetailDialog: Actions.ICareerDetailDialog = {
			apllType: aplType,
			careerID,
			classID: 'CL000000',
			curriculumFlg: '1',
			setApplicationStatusDialog: true,
			setOpenCareerDetailDialog: false,
			setOpenCurriculumDetailDialog: false,
		};
		this.props.setCareerDetailDialog(careerDetailDialog);
	}

	/**
	 * 申請取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showCancelApplication(e: React.MouseEvent<HTMLElement>) {
		if (this.props.data) {
			const cardData: Actions.ICurriculum = this.props.data;
			const { aplType, careerID } = cardData;
			let to = Routes.getPath(Screens.PERSONAL_APPLICATION_CANCEL);
			to = to.replace(/\/:career_id/, `/${careerID}`);
			to = to.replace(/\/:class_id/, `/CL000000`);
			to = to.replace(/\/:apl_type/, `/${aplType}`);
			this.props.pushHistoryState(to, {
				caller: window.location.pathname,
			});
		}
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 受講取消画面表示
	 * @param e イベントオブジェクト
	 */
	protected showStCancel(e: React.MouseEvent<HTMLElement>) {
		const cardData: Actions.ICurriculum = this.props.data;
		const { careerID } = cardData;
		let to = Routes.getPath(Screens.PERSONAL_LECTURE_CANCEL);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:class_id/, `/CL000000`);
		to = to.replace(/\/:curriculum_flg/, `/1`);
		this.props.pushHistoryState(to, { caller: window.location.pathname });
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * 詳細画面表示
	 * @param e イベントオブジェクト
	 */
	protected showDetail(e: React.MouseEvent<HTMLElement>) {
		const { careerID } = this.props.data;
		let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_DETAIL);
		to = to.replace(/\/:curriculum_id/, `/${careerID}`);
		this.props.pushHistory(to);
		this.setState({ functionMenuAnchorEl: undefined });
	}

	/**
	 * カリキュラム内容表示
	 * @param event イベントオブジェクト
	 */
	protected showContent(event: React.MouseEvent<HTMLElement>) {
		const rowData: Actions.ICurriculum = this.props.data;
		const { careerID } = rowData;
		let to = Routes.getPath(Screens.PERSONAL_CURRICULUM_CONTENT);
		to = to.replace(/\/:career_id/, `/${careerID}`);
		to = to.replace(/\/:cur_type/, `/${this.props.type}`);
		this.props.pushHistory(to);
	}
}

const mapStateToProps = (state: IRootState) => ({
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchCurriculumDetail: (curriculumId: string, token: string) => {
		const s = SearchScenarioFactory.createFetchCurriculumDetail(
			dispatch,
			token
		);
		s.run(curriculumId);
	},
	pushHistory: (path: string) => dispatch(push(path)),
	pushHistoryState: (path: string, state: any) =>
		dispatch(
			push({
				pathname: path,
				state,
			})
		),
	setCareerDetailDialog: (CareerDetailDialog: Actions.ICareerDetailDialog) =>
		dispatch(Actions.setCareerDetailDialog({ CareerDetailDialog })),
});

export interface ICurriculumCardProps {
	data: Actions.ICurriculum;
	type: CurriculumTypes;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ICurriculumCardProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CurriculumCard);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/components/CurriculumCard.tsx